(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seenKey = 'ron-access-invitation-v1';

  function invite(root) {
    if (root.dataset.accessMotionReady) return;
    root.dataset.accessMotionReady = 'true';
    if (reduced.matches || !Element.prototype.animate) return;
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation?.type === 'back_forward') return;
    try {
      if (sessionStorage.getItem(seenKey)) return;
    } catch (_) {}

    const photo = root.querySelector('.ral-photo');
    if (!photo) return;
    if ('IntersectionObserver' in window && photo.getBoundingClientRect().top >= innerHeight) {
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        reveal(root, photo);
      }, { threshold: .15 });
      observer.observe(photo);
      window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
    } else {
      reveal(root, photo);
    }
  }

  function reveal(root, photo) {
    if (reduced.matches || root.contains(document.activeElement)) return;
    try {
      if (sessionStorage.getItem(seenKey)) return;
      sessionStorage.setItem(seenKey, '1');
    } catch (_) {}
    const curtain = document.createElement('div');
    curtain.className = 'ral-curtain';
    curtain.setAttribute('aria-hidden', 'true');
    [root.dataset.accessBrand, root.dataset.accessLabel].forEach((label, index) => {
      const panel = document.createElement('span');
      panel.className = `ral-curtain-panel ral-curtain-panel--${index ? 'right' : 'left'}`;
      panel.textContent = label || '';
      curtain.append(panel);
    });

    const animations = [];
    let deadline;
    const finish = () => {
      clearTimeout(deadline);
      curtain.remove();
      animations.forEach(animation => animation.cancel());
      root.removeEventListener('focusin', finish);
      root.removeEventListener('pointerdown', finish);
      window.removeEventListener('pagehide', finish);
      reduced.removeEventListener('change', finish);
    };
    deadline = window.setTimeout(finish, 1000);
    root.addEventListener('focusin', finish, { once: true });
    root.addEventListener('pointerdown', finish, { once: true });
    window.addEventListener('pagehide', finish, { once: true });
    reduced.addEventListener('change', finish, { once: true });

    try {
      photo.append(curtain);
      const timing = { duration: 720, easing: 'cubic-bezier(.76,0,.24,1)', fill: 'forwards' };
      for (const [index, panel] of [...curtain.children].entries()) {
        animations.push(panel.animate([
          { transform: 'translateX(0)' },
          { transform: `translateX(${index ? '' : '-'}101%)` }
        ], timing));
      }
      const title = root.querySelector('.ral-hero h1');
      if (title && title.getBoundingClientRect().bottom > 0) animations.push(title.animate([
        { opacity: .6, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' }));
      Promise.all(animations.map(animation => animation.finished)).then(finish, finish);
    } catch (_) {
      finish();
    }
  }

  document.querySelectorAll('[data-access-invitation]').forEach(invite);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-access-invitation]').forEach(invite);
  });
})();
